
import React from 'react';

const LoadingSpinner = ({ fullscreen = false, size = 40 }) => {
  const spinner = (
    <div style={{
      width: size, height: size,
      border: `3px solid rgba(139, 92, 246, 0.2)`,
      borderTopColor: '#8b5cf6',
      borderRadius: '50%',
      animation: 'spin 0.8s linear infinite'
    }} />
  );

  if (fullscreen) {
    return (
      <div style={{
        position: 'fixed', inset: 0,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'var(--bg-primary)', zIndex: 9999, flexDirection: 'column', gap: '16px'
      }}>
        {spinner}
        <p style={{ color: 'var(--text-muted)', fontSize: '14px', fontFamily: 'var(--font-body)' }}>Loading...</p>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return (
    <>
      {spinner}
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </>
  );
};

export default LoadingSpinner;
